import { cn } from "@/lib/utils";
import type { ComponentPropsWithoutRef, ElementType, ReactElement, ReactNode } from "react";

interface EyebrowProps extends Omit<ComponentPropsWithoutRef<"p">, "children"> {
  as?: ElementType;
  children: ReactNode;
}

export function Eyebrow({ as: Component = "p", children, className, ...props }: EyebrowProps): ReactElement {
  return (
    <Component className={cn("text-xs leading-5 font-semibold text-green-600", className)} {...props}>
      {children}
    </Component>
  );
}
